import { alphaWithSpaces } from 'utils/validators';
import { email, numeric, required, minLength } from 'vuelidate/lib/validators';
var Contact = /** @class */ (function () {
    function Contact() {
        this.email = '';
        this.firstName = '';
        this.lastName = '';
        this.intCode = '';
        this.phoneNumber = '';
        this.errorMsg = {
            email: {
                email: 'reusable.email.validation.invalid',
                missing: 'reusable.email.validation.missing'
            },
            firstName: {
                alphaWithSpaces: 'reusable.firstName.validation.alphaWithSpaces',
                required: 'reusable.firstName.validation.required'
            },
            intCode: {
                required: 'reusable.intCodeWithPhone.validation.intCode.required'
            },
            lastName: {
                alphaWithSpaces: 'reusable.lastName.validation.alphaWithSpaces',
                required: 'reusable.lastName.validation.required'
            },
            phoneNumber: {
                numeric: 'reusable.intCodeWithPhone.validation.phoneNumber.notNumeric',
                required: 'reusable.intCodeWithPhone.validation.phoneNumber.required',
                minLength: 'reusable.intCodeWithPhone.validation.phoneNumber.minlength'
            },
            title: {
                required: 'reusable.paxTitle.validation.required'
            }
        };
        this.validation = {
            form: {
                email: {
                    email: email,
                    missing: required
                },
                firstName: {
                    alphaWithSpaces: alphaWithSpaces,
                    required: required
                },
                intCode: {
                    required: required
                },
                lastName: {
                    alphaWithSpaces: alphaWithSpaces,
                    required: required
                },
                phoneNumber: {
                    numeric: numeric,
                    required: required,
                    minLength: minLength(5)
                },
                title: {
                    missing: required
                }
            }
        };
        this._title = 'Mr';
    }
    Object.defineProperty(Contact.prototype, "title", {
        get: function () {
            return this._title;
        },
        set: function (value) {
            var allowedTitles = ['Mr', 'Ms'];
            var newString = value;
            if (value !== null) {
                newString = value.charAt(0).toUpperCase() + value.slice(1).toLocaleLowerCase();
            }
            if (allowedTitles.indexOf(newString) !== -1) {
                this._title = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    return Contact;
}());
export default Contact;
